<script>
import { layoutMethods,billsPaymentMethods } from "@/state/helpers";
// import Swal from "sweetalert2";

export default {
  page: {
    title: "Sell Bills Payment Transaction Details",
  },
  data() {
    return {
        userId: 0,
        transactionId: 0,
        userDetails: {},
        transactionDetails: {},
        conveDisplay: true
    };
  },
  mounted: async function () {
    this.userId = this.$route.params.userId
    this.transactionId = this.$route.params.id
    this.changeTitle({ title: "Sell Bills Payment Transaction Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Report', to: { name: 'Bills Payment Sell'} },
        { text: 'Bills Payment Sell', to: { name: 'Bills Payment Sell'} },
        { text: 'Details', to: { name: 'Bills Payment Sell Details'} }
      ],
    });
    this.getUserDetails();
    this.getTransactionDetails();
  },
  computed: {
  },
  methods: {
    ...layoutMethods,
    ...billsPaymentMethods,
    getUserDetails(){
      this.actionBillsPayment({
          action: "user-info",
          body: {"user_id":this.userId}
      })
      .then((res) => {
        console.log(JSON.stringify(res));
        this.userDetails = res["message"][0];
      }).catch((e)=>{
        console.log("error while getting Details",e);
      });
    },
    getTransactionDetails(){
      this.actionBillsPayment({
          action: "sell-transaction-info",
          body: {"id":this.transactionId}
      })
      .then((res) => {
        console.log(JSON.stringify(res));
        this.transactionDetails = res["message"][0];
      }).catch((e)=>{
        console.log("error while getting Details",e);
      });
    },
    textCleaner(text = "",as_is = false){
      var return_text = '--';
      if(text != null && text.length > 0){
        return_text = text;
      }
      try {
        if(!isNaN(parseFloat(text)) && !as_is){// handle amounts with decimal
          return_text = parseFloat(text).toFixed(2);
        }
      } catch (error) {
        console.log(error);
      }
      return return_text;
    },
    toggleConve(){
      // alert("hey");
      this.conveDisplay = !this.conveDisplay
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3">
        <!-- Merchant Details card -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex mb-3 border-bottom pb-2 text-dark">
              <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Merchant Details</span>
              </div>
            </div>
            <ul class="list-unstyled mb-0 mt-4">
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-user-circle"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.customer_name)}}</h5>
                  </div>
                </div>
              </li>
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-mobile-alt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Mobile Number</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.mobile_number,true)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-envelope"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Email</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.email)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Business Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.business_name)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
            </ul>
          </div>
        </div>
        <!-- end Merchant Details card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
          <div class="col-lg-12">
            <!-- Transaction Details card -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                  <div class="flex-grow-1 my-auto">
                    <span class="align-middle fw-semibold">Transaction Details</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Transaction ID:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">{{textCleaner(transactionDetails.trans_reference_no)}}</p>
                      </div>
                    </div><!--transaction id-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Biller Name:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">{{textCleaner(transactionDetails.sub_name)}}</p>
                      </div>
                    </div><!--biller name-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Account Number:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">{{textCleaner(transactionDetails.cust_account_no,true)}}</p>
                      </div>
                    </div><!--Account Number-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Amount:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.payment_amount)}}</p>
                      </div>
                    </div><!--Amount-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Service Fee:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.service_fee)}}</p>
                      </div>
                    </div><!--Service Fee-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold" :class="{' m-0': conveDisplay}">
                          Final Convenience Fee: 
                          <span @click="toggleConve()" style="cursor: pointer;"><i class="text-secondary bx" :class="{'bx-chevron-up': conveDisplay,'bx-chevron-down': !conveDisplay}"></i></span>
                        </p>
                          <p class="font-size-12 m-0 mt-1" v-if="conveDisplay">Peddlr Convenience Fee:</p>
                          <p class="font-size-12 m-0 mt-1" v-if="conveDisplay">Supplier Convenience Fee:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13 m-0">₱ {{textCleaner(transactionDetails.final_conve_fee)}}</p>
                        <p class="font-size-12 m-0 mt-1" v-if="conveDisplay">₱ {{textCleaner(transactionDetails.peddlr_conve_fee)}}</p>
                        <p class="font-size-12 m-0 mt-1" v-if="conveDisplay">₱ {{textCleaner(transactionDetails.convenience_fee)}}</p>
                      </div>
                    </div><!--Final Convenience Fee-->
                    <div v-if="conveDisplay" class="mb-3"></div>
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Total Amount:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.tot_trans_amount)}}</p>
                      </div>
                    </div><!--total_amount-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Merchant Share:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.merchant_comm_fee)}}</p>
                      </div>
                    </div><!--Merchant Share-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Peddlr Share:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.peddlr_share_fee)}}</p>
                      </div>
                    </div><!--Peddlr Share-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Cash Back:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">₱ {{textCleaner(transactionDetails.cashback_amount)}}</p>
                      </div>
                    </div><!--Cash Back-->
                    <div class="row m-b-9" v-if="false">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Request Date:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">{{transactionDetails.trans_datetime | formatDate}}</p>
                      </div>
                    </div><!--Request date-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Transaction Status:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13 text-uppercase"
                            :class="{
                                'text-success': transactionDetails.status == 'success',
                                'text-danger': transactionDetails.status == 'failed',
                                'text-warning': transactionDetails.status == 'pending',
                            }">{{textCleaner((transactionDetails.status == 'pending')? "processing":transactionDetails.status)}}</p>
                      </div>
                    </div><!--transaction status-->
                    <div class="row m-b-9">
                      <div class="col-4">
                        <p class="font-size-13 fw-semibold">Error Description:</p>
                      </div>
                      <div class="col-8">
                        <p class="font-size-13">{{textCleaner(transactionDetails.error_details)}}</p>
                      </div>
                    </div>
                  </div><!--end of new details display-->
                </div>
              </div>
            </div>
            <!-- end Transaction Details card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.bl{
  line-break: anywhere;
}
</style>